import React, { Component } from 'react'
import CustomTable from '../../../../../../../elements/Table/CustomTable'
import { Button } from 'antd'

class BillLinesList extends Component {
  render() {
    const { lines, fetchingLines, onShowBillLine, fetchLines } = this.props
    let columns = [
      {
        Header: 'ID',
        accessor: '_key',
        hideDefault: true,
        hideable: true,
      },
      {
        Header: 'OrderLine',
        accessor: 'orderLine._id',
        hideDefault: true,
        hideable: true,
      },
      {
        Header: 'Item No',
        accessor: 'no',
        Cell: ({ value, original }) => <a onClick={() => onShowBillLine(original, 'edit')}>{value}</a>,
        zIndex: -1,
      },
      {
        Header: 'OrderLine No',
        accessor: 'orderLine.no',
        hideDefault: true,
        hideable: true,
      },
      {
        Header: 'Name',
        accessor: 'name',
        width: 300,
        alignment: 'left',
      },
      {
        Header: 'Description',
        accessor: 'description',
        hideDefault: true,
        hideable: true,
      },
      {
        Header: 'Account Code',
        accessor: 'account.code',
        hideDefault: false,
        hideable: true,
      },
      {
        Header: 'percentage',
        accessor: 'percentage',
        Cell: ({ value, original }) => value && `${original.percentage}%`,
        hideDefault: false,
        hideable: true,
      },
      {
        Header: 'Unit',
        accessor: 'unit',
      },
      {
        Header: 'UOM',
        accessor: 'uom.code',
        hideDefault: false,
        hideable: true,
      },
      {
        Header: 'U/Price',
        accessor: 'rate',
      },
      {
        Header: 'U/Tax',
        accessor: 'tax.rate',
      },
      {
        Header: 'Total (EX)',
        accessor: 'amount.net',
      },
      {
        Header: 'Total Tax',
        accessor: 'amount.tax',
      },
      {
        Header: 'Total INC',
        accessor: 'amount.gross',
      },

      {
        Header: 'Tax Type',
        accessor: 'tax.type',
        Cell: ({ value }) => value && value.toUpperCase(),
      },
    ]
    return (
      <CustomTable
        CreateButton={() => (
          <Button disabled={true} type={'primary'} size={'small'} icon={'plus'} onClick={onShowBillLine}>
            New
          </Button>
        )}
        fetch={fetchLines}
        fetching={fetchingLines}
        columns={columns}
        data={lines}
        defaultSorted={[
          {
            id: 'no',
            desc: false,
          },
        ]}
      />
    )
  }
}

BillLinesList.propTypes = {}
BillLinesList.defaultProps = {}

export default BillLinesList
